module.exports = __webpack_public_path__ + "img/service-icon5.bcb6ce6d.png";